import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "text-danger" }

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { PicPayload, PicResponse } from "@/types/interface/pic";
import { usePicStore } from "@/stores/master/pic";
import { useCategoryGroupStore } from "@/stores/master/category-group-store";
import { mapOptionMultiselect } from "@/utils/helper";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { usePositionStore } from "@/stores/master/position";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreatePic',
  setup(__props) {

const idPic = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const picStore = usePicStore();
const detailPic = ref<PicResponse>();
const categoryGroupStore = useCategoryGroupStore();
const listGroupCategory = ref();
const jobStore = usePositionStore();
const listJob = ref();

const validationSchema = toTypedSchema(
  zod.object({
    job_id: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    group_category_id: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: job_id } = useField<any>("job_id");
const { value: group_category_id } = useField<any>("group_category_id");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadPic: PicPayload = {
    job_id: job_id.value?.value,
    group_category_id: group_category_id.value?.value,
  };

  const responseApi = ref<any>();

  if (isEdit.value == true) {
    responseApi.value = await picStore.dispatchUpdate(idPic.value, payloadPic);
  } else {
    responseApi.value = await picStore.dispatchCreate(payloadPic);
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value ? "PIC Successfully Updated" : "PIC Successfully Added"
      );
      router.push("/data/pic");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadDetailPic = async () => {
  const { success, message } = await picStore.dispatchDetail(idPic.value);
  if (success) {
    detailPic.value = await picStore?.pic?.data;
    job_id.value = mapOptionMultiselect(detailPic.value?.job, "id", "name");
    group_category_id.value = mapOptionMultiselect(
      detailPic.value?.groupCategory,
      "id",
      "code",
      "name"
    );
  }
};

const loadListGroupCategory = async () => {
  const { success, message } =
    await categoryGroupStore.dispatchGetCategoryGroups(1, 99);
  if (success) {
    listGroupCategory.value = mapOptionMultiselect(
      await categoryGroupStore.categoryGroups.items,
      "id",
      "code",
      "name"
    );
  }
};

const loadListJob = async () => {
  const { success, message } = await jobStore.dispatchGetPositions(1, 99);
  if (success) {
    listJob.value = mapOptionMultiselect(
      await jobStore.positions.items,
      "id",
      "code",
      "name"
    );
  }
};

loadListGroupCategory();
loadListJob();

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idPic.value = router.currentRoute.value.params.id.toString();
    loadDetailPic();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create PIC"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/data/pic"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List PIC ")
            ])
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[3] || (_cache[3] = _createElementVNode("label", {
                        for: "job_id",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Designation "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_unref(vSelect), {
                          options: listJob.value,
                          name: "job_id",
                          modelValue: _unref(job_id),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(job_id) ? (job_id).value = $event : null)),
                          placeholder: "Choose Designation"
                        }, null, 8, ["options", "modelValue"])
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).job_id), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[4] || (_cache[4] = _createElementVNode("label", {
                        for: "group_category_id",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Group Category "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_unref(vSelect), {
                          options: listGroupCategory.value,
                          name: "group_category_id",
                          modelValue: _unref(group_category_id),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(group_category_id) ? (group_category_id).value = $event : null)),
                          placeholder: "Group Category"
                        }, null, 8, ["options", "modelValue"])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).group_category_id), 1)
                    ])
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Save ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})